export const UPDATE_NEAR_BY_DESTINATIONS = "UPDATE_NEAR_BY_DESTINATIONS";
export const RESET_NEAR_BY_DESTINATIONS = "RESET_NEAR_BY_DESTINATIONS";
export const ADD_MORE_NEAR_BY_DESTINATIONS = "ADD_MORE_NEAR_BY_DESTINATIONS";

export function clearNearByDestinations(){
    return {type: RESET_NEAR_BY_DESTINATIONS};
}
